export const toAbsoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname;

export const toBucketAssets = (pathname) =>
  `https://public-kriptonmarket.s3.us-east-1.amazonaws.com/img/services_assets/assets/${pathname}`;
